// import React, { useState, useEffect } from "react";
// import Axios from "axios";
// import { NavLink } from "react-router-dom";

// const JobAppliedList = () => {
//   const [candidateList, setCandidateList] = useState([]);
//   const [jobList, setJobList] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(5); 

//   const fetchCandidates = async () => {
//     try {
//       const response = await Axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}php/jobapplied_list.php`
//       );
//       setCandidateList(response.data.jobs.sort((a, b) => b.id - a.id));

//     } catch (error) {
//       console.error("Error fetching candidates:", error);
//     }
//   };

//   const fetchJobList = async()=>{
//     try {
//       const response = await Axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}php/joblist.php`
//       );
//       setJobList(response.data.jobs);

//     } catch (error) {
//       console.error("Error fetching candidates:", error);
//     }
//   }

//   useEffect(() => {
//     fetchCandidates();
//     fetchJobList();
//   }, []);

//   const getJobTitle = (jobId) => {
//     const job = jobList.find((job) => job.id === jobId);
//     // console.log("getJobTitle",job);
//     return job ? job.job_title : "Job title not available";
//   };

//   // Logic to calculate the index of candidates to display
//   const indexOfLastCandidate = currentPage * itemsPerPage;
//   const indexOfFirstCandidate = indexOfLastCandidate - itemsPerPage;
//   const currentCandidates = candidateList.slice(
//     indexOfFirstCandidate,
//     indexOfLastCandidate
//   );

//   // Handle page change
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   const handleResumeDownload = (resumeFileName) => {
//     const fullResumeUrl = `${process.env.REACT_APP_API_BASE_URL}php/uploads/resume/${resumeFileName}`;  
//     const link = document.createElement("a");
//     link.href = fullResumeUrl;
//     link.download = resumeFileName;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <div>
//       <div className="table-responsive">
//         <table className="table twm-table table-striped table-borderless">
//           <thead>
//             <tr>
//               <th>No</th>
//               <th>Candidate Name</th>
//               <th>Email Address</th>
//               <th>Mobile No</th>
//               <th>Applied Job</th>
//               <th className="text-center">Resume</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentCandidates.map((candidate, index) => (
//               <tr key={index}>
//                 <td className="order-id text-primary">
//                   {indexOfFirstCandidate + index + 1}
//                 </td>
//                 <td>{candidate.name}</td>
//                 <td>
//                   <a
//                     href={`mailto:${candidate.email}`}
//                     className="text-primary"
//                   >
//                     {candidate.email}
//                   </a>
//                 </td>
//                 <td>
//                   {!candidate.mobile ? (
//                     "Mobile no not available"
//                   ) : (
//                     <a
//                       href={`tel:${candidate.mobile}`}
//                       className="text-primary"
//                     >
//                       {" "}
//                       {candidate.mobile}{" "}
//                     </a>
//                   )}
//                 </td>
//                 <td>{getJobTitle(candidate.job_id)}</td>
//                 <td>
//                   {candidate.upload_resume ? (
//                     <button
//                       onClick={() =>
//                         handleResumeDownload(candidate.upload_resume)
//                       }
//                       className="btn btn-link"
//                     >
//                       Download Resume
//                     </button>
//                   ) : (
//                     "Resume Not Available"
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination Controls */}
//       <div className="pagination-outer text-right">
//         <div className="pagination-style1">
//           <ul className="clearfix">
//             {/* Previous Page */}
//             <li className="prev">
//               <NavLink
//                 to="#"
//                 onClick={() => currentPage > 1 && paginate(currentPage - 1)}
//               >
//                 <span>
//                   <i className="fa fa-angle-left" />
//                 </span>
//               </NavLink>
//             </li>

//             {/* Page Numbers */}
//             {[...Array(Math.ceil(candidateList.length / itemsPerPage))].map(
//               (_, index) => (
//                 <li key={index}>
//                   <NavLink
//                     to="#"
//                     onClick={() => paginate(index + 1)}
//                     className={currentPage === index + 1 ? "active" : ""}
//                   >
//                     {index + 1}
//                   </NavLink>
//                 </li>
//               )
//             )}

//             {/* Next Page */}
//             <li className="next">
//               <NavLink
//                 to="#"
//                 onClick={() =>
//                   currentPage <
//                     Math.ceil(candidateList.length / itemsPerPage) &&
//                   paginate(currentPage + 1)
//                 }
//               >
//                 <span>
//                   <i className="fa fa-angle-right" />
//                 </span>
//               </NavLink>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default JobAppliedList;



import React, { useState, useEffect } from "react";
import Axios from "axios";
import { NavLink } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const JobAppliedList = () => {
  const [candidateList, setCandidateList] = useState([]);
  const [jobList, setJobList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [selectedYear, setSelectedYear] = useState(() => {
    return localStorage.getItem("selectedYear") || "";
  });

  const [selectedMonth, setSelectedMonth] = useState(() => {
    return localStorage.getItem("selectedMonth") || "";
  });
  
  const years = [
  ...new Set(
    candidateList.map((item) =>
      new Date(item.application_date).getFullYear()
    )
  ),
].sort((a, b) => b - a);
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const filteredCandidates = candidateList.filter((candidate) => {
  const date = new Date(candidate.application_date);

  const yearMatch =
    selectedYear === "" ||
    date.getFullYear() === Number(selectedYear);

  const monthMatch =
    selectedMonth === "" ||
    date.getMonth() === Number(selectedMonth);

  return yearMatch && monthMatch;
});

  const fetchCandidates = async () => {
    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_API_BASE_URL}php/jobapplied_list.php`
      );
      setCandidateList(response.data.jobs.sort((a, b) => b.id - a.id));
    } catch (error) {
      console.error("Error fetching candidates:", error);
    }
  };

  const fetchJobList = async () => {
    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_API_BASE_URL}php/joblist.php`
      );
      setJobList(response.data.jobs);
    } catch (error) {
      console.error("Error fetching job list:", error);
    }
  };
const exportToExcel = () => {
  // const excelData = candidateList.map((candidate) => ({
    const excelData = filteredCandidates.map((candidate) => ({
    ID: candidate.id,
    Name: candidate.name,
    Email: candidate.email,
    Mobile: candidate.mobile,
    Job_Title: getJobTitle(candidate.job_id),
    Experience: candidate.experience,
    Qualification: candidate.qualification,
    Resume: candidate.upload_resume
      ? `${process.env.REACT_APP_API_BASE_URL}php/uploads/resume/${candidate.upload_resume}`
      : "",
    Applied_Date: candidate.application_date.split(" ")[0],
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
    excelData.forEach((candidate, index) => {
    if (candidate.Resume) {
      const cellAddress = `H${index + 2}`; // H = Resume column, +2 because row 1 is header

      worksheet[cellAddress] = {
        t: "s",
        v: "Open Resume",
        l: {
          Target: candidate.Resume,
        },
        s: {
          fill: {
            fgColor: { rgb: "E3F2FD" }, // Light blue background
          },
          font: {
            color: { rgb: "0000FF" },
            underline: true,
            bold: true,
          },
        },
      };
    }
  });
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Job Applications"
  );

  // XLSX.writeFile(workbook, "Job_Applications.xlsx");
      const monthName =
      selectedMonth !== ""
        ? months[Number(selectedMonth)]
        : "All_Months";

    const yearName =
      selectedYear !== ""
        ? selectedYear
        : "All_Years";

    const fileName = `Job_Applications_${monthName}_${yearName}.xlsx`;

    XLSX.writeFile(workbook, fileName);
};

  useEffect(() => {
    fetchCandidates();
    fetchJobList();
  }, []);

// useEffect(() => {
//   setCurrentPage(1);
// }, [selectedYear, selectedMonth]);

useEffect(() => {
  localStorage.setItem("selectedYear", selectedYear);
  localStorage.setItem("selectedMonth", selectedMonth);
}, [selectedYear, selectedMonth]);

  const getJobTitle = (jobId) => {
    const job = jobList.find((job) => job.id === jobId);
    return job ? job.job_title : "Job title not available";
  };

  const indexOfLastCandidate = currentPage * itemsPerPage;
  const indexOfFirstCandidate = indexOfLastCandidate - itemsPerPage;
  // const currentCandidates = candidateList.slice(indexOfFirstCandidate, indexOfLastCandidate);
  const currentCandidates = filteredCandidates.slice(
  indexOfFirstCandidate,
  indexOfLastCandidate
);


  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  // const totalPages = Math.ceil(candidateList.length / itemsPerPage);
  const totalPages = Math.ceil(
  filteredCandidates.length / itemsPerPage
);

  const handleResumeDownload = (resumeFileName) => {
    const fullResumeUrl = `${process.env.REACT_APP_API_BASE_URL}php/uploads/resume/${resumeFileName}`;
    const link = document.createElement("a");
    link.href = fullResumeUrl;
    link.download = resumeFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Ellipsis pagination helper
  const renderPageNumbers = () => {
    const pageNumbers = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pageNumbers.push(1, 2, 3, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pageNumbers.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pageNumbers.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }

    return pageNumbers;
  };

  return (
    <div>
      <div className="table-responsive">

        <div className="row mb-3">

          <div className="col-md-3">
            <select
              className="form-control"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              <option value="">All Years</option>

              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <select
              className="form-control"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              <option value="">All Months</option>

              {months.map((month, index) => (
                <option key={index} value={index}>
                  {month}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <button
              className="btn btn-success"
              onClick={exportToExcel}
            >
              Export to Excel
            </button>
          </div>

        </div>
        <table className="table twm-table table-striped table-borderless">
          <thead>
            <tr>
              <th>No</th>
              <th>Candidate Name</th>
              <th>Email Address</th>
              <th>Mobile No</th>
              <th>Position</th>
              <th>Applied Job</th>
              <th className="text-center">Resume</th>
            </tr>
          </thead>
          <tbody>
            {currentCandidates.map((candidate, index) => (
              <tr key={index}>
                <td className="order-id text-primary">
                  {indexOfFirstCandidate + index + 1}
                </td>
                <td>{candidate.name}</td>
                <td>
                  <a href={`mailto:${candidate.email}`} className="text-primary">
                    {candidate.email}
                  </a>
                </td>
                <td>
                  {!candidate.mobile ? (
                    "Mobile no not available"
                  ) : (
                    <a href={`tel:${candidate.mobile}`} className="text-primary">
                      {candidate.mobile}
                    </a>
                  )}
                </td>
                <td>{candidate.position}</td>
                <td>{getJobTitle(candidate.job_id)}</td>
                <td>
                  {candidate.upload_resume ? (
                    <button
                      onClick={() => handleResumeDownload(candidate.upload_resume)}
                      className="btn btn-link"
                    >
                      Download Resume
                    </button>
                  ) : (
                    "Resume Not Available"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="pagination-outer text-right">
        <div className="pagination-style1">
          <ul className="clearfix">
            {/* Previous */}
            <li className="prev">
              <NavLink
                to="#"
                onClick={() => currentPage > 1 && paginate(currentPage - 1)}
              >
                <span>
                  <i className="fa fa-angle-left" />
                </span>
              </NavLink>
            </li>

            {/* Page Numbers with Ellipsis */}
            {/* {renderPageNumbers().map((page, index) => (
              <li key={index}>
                {page === "..." ? (
                  <span className="px-2">...</span>
                ) : (
                  <NavLink
                    to="#"
                    onClick={() => paginate(page)}
                    className={currentPage === page ? "active" : ""}
                  >
                    {page}
                  </NavLink>
                )}
              </li>
            ))} */}
            {renderPageNumbers().map((page, index) => (
              <li key={index} className={currentPage === page ? "active" : ""}>
                {page === "..." ? (
                  <span className="px-2">...</span>
                ) : (
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      paginate(page);
                    }}
                  >
                    {page}
                  </a>
                )}
              </li>
            ))}

            {/* Next */}
            <li className="next">
              <NavLink
                to="#"
                onClick={() => currentPage < totalPages && paginate(currentPage + 1)}
              >
                <span>
                  <i className="fa fa-angle-right" />
                </span>
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default JobAppliedList;
